import backhandIcon from "../assets/competency/backhand.png";
import effectsIcon from "../assets/competency/effects.png";
import firstContactIcon from "../assets/competency/first-contact.png";
import forehandIcon from "../assets/competency/forehand.png";
import fundamentalsIcon from "../assets/competency/fundamentals.png";
import gameSchemeIcon from "../assets/competency/game-scheme.png";
import lateralIcon from "../assets/competency/lateral.png";
import playstylesIcon from "../assets/competency/playstyles.png";

function fold(value) {
  return String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();
}

const ICON_RULES = [
  {
    src: firstContactIcon,
    test: /first contact|premier contact|erster ballkontakt|primer contacto/,
  },
  {
    src: fundamentalsIcon,
    test: /fundamentals|fondamentaux|grundlagen|fundamentos/,
  },
  {
    src: forehandIcon,
    test: /forehand|coup droit|vorhand|derecha/,
  },
  {
    src: backhandIcon,
    test: /backhand|\brevers\b|ruckhand|\breves\b/,
  },
  {
    src: lateralIcon,
    test: /lateral connection|liaison lateral|seitlicher anschluss|conexion lateral/,
  },
  {
    src: effectsIcon,
    test: /the effects|les effets|die auswirkungen|los efectos|\beffects\b|\beffets\b/,
  },
  {
    src: playstylesIcon,
    test: /playstyles|play styles|styles de jeu|spielstile|estilos de juego/,
  },
  {
    src: gameSchemeIcon,
    test: /game scheme|game patterns?|schema de jeu|spielschema|esquema de juego/,
  },
];

function labelsOf(blockOrName) {
  if (blockOrName && typeof blockOrName === "object") {
    return [
      blockOrName.name,
      blockOrName.cb,
      blockOrName.label,
      blockOrName.cb_name_en,
      blockOrName.cb_name_fr,
      blockOrName.cb_name_de,
      blockOrName.cb_name_es,
      // Blocks-of-competency picker lists CBs as subtypes
      blockOrName.sub_type_name_en,
      blockOrName.sub_type_name_fr,
      blockOrName.sub_type_name_de,
      blockOrName.sub_type_name_es,
    ].filter((value) => value != null && String(value).trim());
  }
  return blockOrName ? [blockOrName] : [];
}

/** Icon for a competency block, or null when this block has no dedicated mark. */
export function competencyBlockIconSrc(blockOrName) {
  const blob = fold(labelsOf(blockOrName).join(" "));
  if (!blob) return null;
  const match = ICON_RULES.find((rule) => rule.test.test(blob));
  return match ? match.src : null;
}
